import { render, staticRenderFns } from "./currencyCharge.vue?vue&type=template&id=65fae02c&scoped=true"
import script from "./currencyCharge.vue?vue&type=script&lang=js"
export * from "./currencyCharge.vue?vue&type=script&lang=js"
import style0 from "./currencyCharge.vue?vue&type=style&index=0&id=65fae02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fae02c",
  null
  
)

export default component.exports